import { P2GButton } from '@parcel2go/core-ui';
import { ReactNode } from 'react';

export const SuperButton = ({
  children,
  onClick,
  variant
}: {
  children: ReactNode;
  onClick: () => void;
  variant?: 'primary' | 'secondary' | 'tertiary';
}) => (
  <P2GButton onClick={onClick} variant={variant} style={{ minWidth: 'unset', height: 'unset' }}>
    {children}
  </P2GButton>
);
